import React from 'react'
import Layout from '../../Layout/Layout'
import ResumeData from './ResumeData'

const JobRequest = () => {
  return (
   <Layout>
     <ResumeData/>
    </Layout>
  )
}

export default JobRequest

